import type { Theme } from '@lemonade-hq/uniclient-theme';
import { useTheme } from '@lemonade-hq/uniclient-theme';
import { useLayoutEffect, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

const brandMap = {
  b: 'bluish',
  p: 'pinkish',
  r: 'reddish',
} as const;

const schemeMap = {
  d: 'dark',
  l: 'light',
} as const;
type SchemeKey = keyof typeof schemeMap;
type BrandKey = keyof typeof brandMap;
type UrlTheme = `${SchemeKey}${BrandKey}`;

export const ThemeSelector: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { brand, scheme } = useMemo((): Theme => {
    const searchParams = new URLSearchParams(location.search);
    const param = searchParams.get('_t') as UrlTheme | null;

    if (param == null) {
      return { brand: 'pinkish', scheme: 'light' };
    }

    const [schemeKey, brandKey] = param.split('') as [SchemeKey, BrandKey];

    return { brand: brandMap[brandKey], scheme: schemeMap[schemeKey] };
  }, [location.search]);

  const { setTheme } = useTheme();

  useLayoutEffect(() => {
    setTheme({ brand, scheme });
  }, [brand, scheme, setTheme]);

  return children;
};
